<template>
  <div class="notice">
    <van-nav-bar :title="title" fixed border>
      <template #left>
        <img src="../../assets/img/icon/left-arrow.png" class="icon" @click="goBack()" />
      </template>
    </van-nav-bar>
    <div class="notice-t">
    	<div class="empty" v-if="items.length==0"><span class="msg">暂无数据</span></div>
      <div class="cell" v-for="(item,index) in items" :key="index" v-else>
        <h5 class="title">{{item.title}}</h5>
        <div class="time">公告时间：{{item.create_time}}</div>
        <div class="content">{{item.content}}</div>
      </div>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { Collapse, CollapseItem } from "vant";
export default {
  name: "notice",
  components: {
    "van-collapse": Collapse,
    "van-collapse-item": CollapseItem
  },
  data() {
    return {
      title: "公告",
      items: [],
      u_id: localStorage.getItem("u_id"),
      token: localStorage.getItem(localStorage.getItem("u_id") + "token")
    };
  },
  mounted() {
    // 获取浏览器可视区域高度
    this.winH = `${document.documentElement.clientHeight}`;
    window.onresize = function temp() {
      this.winH = `${document.documentElement.clientHeight}`;
    };
  },
  created() {
    this.loadData();
  },
  methods: {
    goBack() {
      this.$router.push({
        name: "My",
        query: {
          active: 3
        }
      });
    },
    loadData() {
      var params = {
        u_id: this.u_id,
        token: this.token
      };
      var url = this.Conf.serverUrl + "userNotice/getNotice" + "?num="+Math.random();
      this.$axios
        .get(url, this.$qs.stringify(params))
        .then(response => {
          this.items = response.data.data;
        })
        .catch(error => {});
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/My/Notice.vue